module.exports = __webpack_public_path__ + "img/eco_bw.543300a1.jpg";